import { BusinessSettings } from '@prisma/client';
import { useMutation } from '@tanstack/react-query';
import { UpdateBusinessSettingsPayload } from '../../types/businesses';
import { handleUpdateBusinessSettings } from '../../helpers/businesses';
import useUser from '../global/useUser';
import useGetOnboarding from './useGetOnboarding';
import useGetBusinessSettings from './useGetBusinessSettings';

interface Options {
  onSuccess?: (result: BusinessSettings | null) => void | Promise<void>;
}

function useUpdateBusinessSettings({ onSuccess }: Options = {}) {
  const { user, reloadUser } = useUser();
  const { refetch: refetchSettings } = useGetBusinessSettings();
  const { reloadAfterUpdate } = useGetOnboarding();

  return useMutation({
    mutationFn: async (payload: UpdateBusinessSettingsPayload) => {
      if (!user?.business?.id) return null;
      const result = await handleUpdateBusinessSettings(
        user.business.id,
        payload,
      );
      return result;
    },
    onSuccess: async result => {
      if (!result) return;
      reloadAfterUpdate('SHOP_SETTINGS');
      await refetchSettings();
      await reloadUser();
      await onSuccess?.(result);
    },
  });
}

export default useUpdateBusinessSettings;
